module.exports = __webpack_public_path__ + "static/img/planzx5ad3ec8.png";